import axios from 'axios';
import normalAxios from '../baseConfig';

let noTokenAxios = axios.create({
    timeout: normalAxios.timeout, // 请求超时设置
    withCredentials: false // 跨域请求是否需要携带 cookie
});

//开始请求设置，发起拦截处理
noTokenAxios.interceptors.request.use(
    (config) => {
        config = normalAxios.request(config);
        return config;
    },
    (error) => {
        return normalAxios.requestError(error);
    }
);
// respone拦截器
noTokenAxios.interceptors.response.use(
    (response) => {
        return normalAxios.response(response);
    },
    (error) => {
        return normalAxios.responseError(error);
    }
);

export default noTokenAxios;
